export class ExportBuildCreatedBy {
    constructor(data) {
        this.userId = data.userId;
        this.userName = data.userName;
    }
}
/**
 * The enum representing possible statuses of an export build.
 * @enum {string}
 */
export var ExportBuildStatus;
(function (ExportBuildStatus) {
    ExportBuildStatus["InProgress"] = "InProgress";
    ExportBuildStatus["Success"] = "Success";
    ExportBuildStatus["Failed"] = "Failed";
    ExportBuildStatus["Timeout"] = "Timeout";
})(ExportBuildStatus || (ExportBuildStatus = {}));
/** Build run entry */
export class ExportBuild {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.index = (_a = data.index) !== null && _a !== void 0 ? _a : null;
        this.id = data.id;
        this.createdAt = new Date(data.createdAt);
        this.finishedAt = data.finishedAt ? new Date(data.finishedAt) : null;
        this.designSystem = data.designSystem;
        this.designSystemVersion = data.designSystemVersion;
        this.result = (_b = data.result) !== null && _b !== void 0 ? _b : null;
        this.status = data.status;
        this.estimatedExecutionTime = (_c = data.estimatedExecutionTime) !== null && _c !== void 0 ? _c : null;
        this.createdBy = (_d = data.createdBy) !== null && _d !== void 0 ? _d : null;
        this.destinations = data.destinations;
        this.scheduleId = (_e = data.scheduleId) !== null && _e !== void 0 ? _e : null;
        this.exporterId = data.exporterId;
        this.brandId = (_f = data.brandPersistentId) !== null && _f !== void 0 ? _f : null;
        this.themeId = (_g = data.themePersistentId) !== null && _g !== void 0 ? _g : null;
    }
    /**
     * Gets the URL for downloading the code generated by the export build.
     * @returns {string|null} - The URL for downloading the code, or null if not available.
     */
    get downloadCodeUrl() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.s3) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : null;
    }
    /**
     * Gets the URL for the pull request associated with the export build.
     * @returns {string|null} - The URL for the pull request, or null if not available.
     */
    get pullRequestUrl() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        return ((_j = (_f = (_c = (_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.azure) === null || _b === void 0 ? void 0 : _b.pullRequestUrl) !== null && _c !== void 0 ? _c : (_e = (_d = this.result) === null || _d === void 0 ? void 0 : _d.bitbucket) === null || _e === void 0 ? void 0 : _e.pullRequestUrl) !== null && _f !== void 0 ? _f : (_h = (_g = this.result) === null || _g === void 0 ? void 0 : _g.github) === null || _h === void 0 ? void 0 : _h.pullRequestUrl) !== null && _j !== void 0 ? _j : (_l = (_k = this.result) === null || _k === void 0 ? void 0 : _k.gitlab) === null || _l === void 0 ? void 0 : _l.pullRequestUrl);
    }
    /**
     * Returns the URL for published documentation associated with the export build.
     * @returns {string|null} - The URL to the documentation, or null if not available.
     */
    get documentationUrl() {
        var _a, _b;
        return ((_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.documentation) === null || _b === void 0 ? void 0 : _b.url) || null;
    }
}
